export default __webpack_public_path__ + "31669b2ce6318896cb25b4dce9b8c759.png";